// extracted by mini-css-extract-plugin
export default {"mediaNews":"index_mediaNews_qsKnw","swiperWp":"index_swiperWp_uglkY","swiperItem":"index_swiperItem_YZuYN","textPart":"index_textPart_CGQtD","videoList":"index_videoList_4COk1"};